import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridComponent } from './Components/grid/grid.component';
import { DatePipe } from '@angular/common';
import { TableModule } from '../../primeng/components/table/table';
import { ConfirmDialogModule } from '../../primeng/components/confirmdialog/confirmdialog';
import { DialogModule } from '../../primeng/components/dialog/dialog';
import { FilterByPipe } from '../../pipes/filter-by.pipe';
import { GetLookupLabelPipe } from '../../pipes/get-lookup-label.pipe';
import { UploaderModule } from '../../Uploader/uploader.module';
import { Angular2AirDatepickerModule } from '../../components/calendar/angular2-air-datepicker.module';
import { PopupModule } from '../../modules/popup/popup.module';
import { LinkSharedModule } from '../shared-module/link-shared.module';
import { LinkMutliselectModule } from 'Shared/components/link-mutliselect/link-mutliselect.module';

@NgModule({
  declarations: [
    GridComponent,
    //FilterByPipe,
    //GetLookupLabelPipe,
    //ConfirmationPopupComponent
  ],
  imports: [
    TableModule,
    ConfirmDialogModule,
    DialogModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    //CalendarModule,
    UploaderModule,
    Angular2AirDatepickerModule,
    PopupModule,
    LinkSharedModule,
    LinkMutliselectModule
  ],
  exports: [
    GridComponent
  ],
  providers: [
    //ConfirmationService,
    DatePipe,
    //PopupService
  ]
})
export class GridModule { }
